<script lang="ts">
    import { afterUpdate, onMount } from "svelte"

    export let bitmap: ImageBitmap
    export let canvas: HTMLCanvasElement | undefined = undefined
    onMount(() => {
        const ctx = canvas!.getContext("2d")
        ctx!.drawImage(bitmap, 0, 0)
    })

    afterUpdate(() => {
        const ctx = canvas!.getContext("2d")
        ctx!.drawImage(bitmap, 0, 0)
    })
</script>

<canvas bind:this={canvas} height={bitmap.height} width={bitmap.width} {...$$restProps} />
